import React from 'react';
import $ from 'jquery';
//import kuromoji from 'kuromoji';
import Chip from '@material-ui/core/Chip';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import moment from 'moment';
import IconButton from '@material-ui/core/IconButton';
import ShareIcon from '@material-ui/icons/Share';
import { withStyles } from '@material-ui/core/styles';

const twitterTag = {
  '0400': 'nhk',
  '0408': 'etv',
  '0410': 'ntv',
  '0428': 'tvasahi',
  '0418': 'tbs',
  '0430': 'tvtokyo',
  '0420': 'fujitv',
  '5c3a': 'mxtv'
};

const regExceptWords = /[【\[][^】\]]+[】\]]|\([^\)]+\)|（[^）)]+[）)]|〈[^〉]+〉|<[^>]+>|（[^）]+）|※.+|ほか/g;

const styles = {
  chip: {margin:2, fontSize:12}
}

class ProgramLink extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tokenizer: undefined,
      name: undefined,
      shareLinkEnable: false
    };
  }

  openLink = (url) => {
    window.open(url, '_blank', 'width=1024, height=960');
  }

  openRelationLinks = (name) => {
    //this.setState({name: name});
    //this.openLink('https://ja.wikipedia.org/wiki/' +encodeURIComponent(name));
    //this.openLink('https://www.google.co.jp?ei=RXi1W4LpCsvN_wSs6KjIBw&q=' +encodeURIComponent(name));
    //TODO: パラメータ確認する
    this.openLink('https://www.google.co.jp/search?q='+encodeURIComponent(name) +'&gs_l=');
  }

  // pickupWords = (text) => {
  //   if (this.state.tokenizer === undefined) return '';
  //   const results = this.state.tokenizer.tokenize(text);
  //   return results.filter(item => item.pos === '名詞')
  //     .map(item => <span class="word">{item.surface_form}</span>);
  // }

  pickupCasts = (text) => {
    return text.replace(regExceptWords, ',').split(/[,，　、/ ／・]+/)
    .filter(item => item.trim() !== '' && item.indexOf('〜') === -1)
    .map((item, i) => {
      let parts = item.trim().split(/[:…]+/);
      let name = parts.length > 1? parts[1] : parts[0];
      return <span key={'cast-'+i} className="word"><a onClick={ext => this.openRelationLinks(name)}>{name}</a></span>
    });
  }

  handleShareButtonClick = () => {
    this.setState({shareLinkEnable: !this.state.shareLinkEnable});
  };

  shouldComponentUpdate = (nextProps, nextState) => {
    return nextProps.program !== this.props.program ||
    nextProps.currentSubtitle !== this.props.currentSubtitle ||
    nextProps.isMulti !== this.props.isMulti ||
    nextProps.programs !== this.props.programs ||
    nextState.name !== this.state.name ||
    nextState.shareLinkEnable !== this.state.shareLinkEnable ||
    nextProps.currentDateTime !== this.props.currentDateTime;
  }
  componentWillMount = () => {
    //var self = this;
    // kuromoji.builder({ dicPath: "./dict/" }).build(function (err, tokenizer) {
    //   self.setState({tokenizer: tokenizer});
    // });
    this.setState({program: this.props.program});
  }
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.program !== undefined && nextProps.program !== this.state.program) {
      this.setState({program: nextProps.program, name: undefined, shareLinkEnable:false});
    }
  }
  render = () => {
    const program = this.props.program;
    const service = this.props.service;
    //const subtitle = this.props.currentSubtitle;
    const isMulti = this.props.isMulti;
    const className = isMulti? "multi" : "";
    if (!program) return (<div id="program-link" className={className}></div>);
    let links = [];
    let relationLinks = [];
    var self = this;

    // if (this.props.isMulti) {
      if (program.genres) {
        const genreItems = program.genres
          .filter((item, i, a) => {
            if (i > 0 && a[i-1].genre === item.genre) return false;
            return item.genre.indexOf('［') === -1;
          })
          .map((item, i) => {
            //relationLinks.push(<GenreLinks {...self.props} suffix='] の番組' name={item.genre}/>);
            return withStyles(styles.chip)(<Chip
                  key={'genre-'+i}
                >
                {item.genre}
                </Chip>)

          });
        links.push(<div className="outside-genre" key={genreItems.length} style={{display: 'flex',flexWrap: 'wrap'}}>{genreItems}</div>);
      }
      if (program.cast) {
        links.push(<div key="cast">{self.pickupCasts(program.cast)}</div>);
      }
    // }
    // Twitter HashTag
    const tag = twitterTag[service.service_id];
    if (tag !== undefined) {
      const url = 'https://twitter.com/search?f=tweets&vertical=news&q=%23'+tag;
      links.push(
        <div key="link" className="link">
          <a
            target="_blank"
            onClick={ext => this.openLink(url)}
          >
            <img alt="twitter" src="/btn_twitter_s.png"/>
            #{tag}
          </a>
        </div>
      );
    }
    // リンク抽出
    if (program.items) {
      $(program.items).each(function() {
        const item = this;
        $(item.item).each(function() {
          const res = this.match(/https?[^\s]+/g);
          if (res) {
            const url = res[0];
            links.push(
              <div className="link">
                <a
                target="_blank"
                onClick={ext => self.openLink(url)}
                >
                  {url}
                </a>
              </div>
            );
          }
        });
      });
    }
    // let words = [];
    // // 形態素解析
    // if (this.props.isMulti && this.state.tokenizer !== undefined && subtitle !== undefined && subtitle !== '') {
    //   let text = subtitle.replace(/<[^>]+>/g, '');
    //   const results = this.state.tokenizer.tokenize(text);
    //   //console.log('subtitle', results);
    //   words = results.filter(item => item.pos === '名詞')
    //     .map(item => <span class="word">{item.surface_form}</span>);
    //     links.push(<div id="words">{words}</div>);
    // }
    if (this.state.name !== undefined) {
      relationLinks.push(<PersonLinks {...this.props} suffix='] の出演番組' name={this.state.name}/>);
    }
    return (
      <div
        id="program-link"
        className={className}
      >
        <div className="program-name">
          {program.name}
          <IconButton
            onClick={this.handleShareButtonClick}
            style={{color:'white'}}
          >
            <ShareIcon />
          </IconButton>
          <ShareLink
          {...this.props}
          shareLinkEnable={this.state.shareLinkEnable}
          />
        </div>
        <div>
          {links}
          {relationLinks}
        </div>
      </div>
    );
  };
}

class PersonLinks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentWillMount = () => {
    this.setState({program: this.props.program});
  }

  render = () => {
    //const program = this.props.program;
    const programs = this.props.programs;
    const service = this.props.service;
    const name = this.props.name;
    const suffix = this.props.suffix;
    if (name === undefined || programs === undefined) return (<div></div>);
    const self = this;
    let relationPrograms =
      programs
      .filter(item => {
        const program = Object.values(item)[0];
        return program.cast !== null && program.cast.indexOf(name) !== -1;
      })
      .map(item => {
        const program = Object.values(item)[0];
        return <div className="relation-program">
          <span></span>
          <a onClick={ext => self.props.onSelectProgram(program, service)}>{program.name}</a>
        </div>
      });
    return (
      <Card>
        <CardHeader
          id="person-information"
          title={'[' +this.props.name +suffix}
          actAsExpander={true}
          showExpandableButton={true}
        />
        <CardContent expandable={true}>
          {relationPrograms}
        </CardContent>
      </Card>
    );
  }
}
class GenreLinks extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  // openPersonInfomation = (name) => {
  //   this.openLink('https://ja.wikipedia.org/wiki/' +encodeURIComponent(name));
  //   //this.openLink('https://www.google.co.jp?ei=RXi1W4LpCsvN_wSs6KjIBw&q=' +encodeURIComponent(name));
  // }
  //
  handleSelectProgram = (program, service) => {
    if (program.start_time*1000 > new Date().getTime()) return;
    this.props.onSelectProgram(program, service);
  }
  componentWillMount = () => {
    this.setState({program: this.props.program});
  }

  render = () => {
    //const program = this.props.program;
    const programs = this.props.programs;
    const service = this.props.service;
    const name = this.props.name;
    const suffix = this.props.suffix;
    if (name === undefined || programs === undefined) return (<div></div>);
    const self = this;
    let relationPrograms =
      programs
      .filter(item => {
        const program = Object.values(item)[0];
        if (program.genres === null) return false;
        const genreItems = program.genres
          .filter(genreItem => (genreItem.genre.indexOf(name) !== -1));
        return genreItems.length > 0;
      })
      .map(item => {
        const program = Object.values(item)[0];
        const style = {};
        if (program.start_time*1000 > new Date().getTime()) {
          style.textDecoration = 'none';
        }
        return <div class="relation-program">
          <span>{moment(program.start_time*1000).format('HH:mm')}&nbsp;</span>
          <a style={style} onClick={ext => self.handleSelectProgram(program, service)}>
          {program.name}
          </a>
        </div>
      });
    return (
      <Card>
        <CardHeader
          id="person-information"
          title={'[' +this.props.name +suffix}
          actAsExpander={true}
          showExpandableButton={true}
        />
        <CardContent expandable={true}>
          {relationPrograms}
        </CardContent>
      </Card>
    );
  }
}

class ShareLink extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  render = () => {
    let program = this.props.program
    let service = this.props.service
    let currentTime = this.props.currentDateTime ? moment(this.props.currentDateTime) : moment()
    if (!this.props.shareLinkEnable) return (<div></div>);
    // const urlBase = window.location.protocol +'//' + window.location.hostname + '/' +service.remote_control_key_id +'?t=';
    // const startUrl = urlBase + moment(program.start_time*1000).format('YYYYMMDD-HHmmss');
    // const currentUrl = urlBase + currentTime.format('YYYYMMDD-HHmmss');

    const urlBase = window.location.protocol +'//' + window.location.hostname + '/' +service.remote_control_key_id +'/'
      +program.event_id;
    const startUrl = urlBase;
    const currentUrl = urlBase +'?t=' + parseInt((currentTime - moment(program.start_time*1000)) / 1000);

    const style = {padding: 16, backgroundColor: 'rgba(128,128,128,.2)',fontSize: 14}
    const spanStyle = {userSelect: 'all', padding:6, border: '1px solid gray', lineHeight: '2.4em'};
    return (
      <div style={style}>
        <div>
          <div>番組先頭</div>
          <div><span style={spanStyle}>{startUrl}</span></div>
        </div>
        <div>
          <div>再生位置</div>
          <div><span style={spanStyle}>{currentUrl}</span></div>
        </div>
      </div>
    )
  }
}

export default ProgramLink;



// WEBPACK FOOTER //
// ./src/components/ProgramLink.js